export const iconFontAwesomePhotosImagesPhotoFilm = (
	<i className="fa-solid fa-photo-film"></i>
);
